import styled from "styled-components"

interface GridProps {
    gridTemplateColumns: string
}
export const GridTableHeaderWrapper = styled.header<GridProps>`
  color: #ffffff;
  border: 0;
  background: #353536;
  display: grid;
  grid-template-columns: ${props => props.gridTemplateColumns};
`

export const GridTableListItemWrapper = styled.div<GridProps>`
  display: grid;
  grid-template-columns: ${props => props.gridTemplateColumns};
  font-size: 0.9rem;
  text-align: center !important;
  vertical-align: middle;
  border-bottom: 1px solid #d1d4d7;
  &:hover {
    background: #f2f7fa;
  };
  &:first-child {
    margin-top: 5px;
  };
`

export const GridTableColumn = styled.div`
  text-align: center;
  line-height: 45px;
  height: 45px;
  font-size: 1rem;
  font-weight: 400;
  vertical-align: middle;
  padding: 2px;
`